// Списки, що гортаються з сервера (заявки, сесії тестів), приймають
// limit/offset, а адмінка тримає в адресі page/limit — раніше сторінка
// просто не доходила до сервера, тому пагінація не працювала.
export function buildListQuery(params = {}, { defaultLimit = 10, extraKeys = [] } = {}) {
  const limit = Math.max(Number(params.limit) || defaultLimit, 1);
  const page = Math.max(Number(params.page) || 1, 1);

  const query = {
    limit: String(limit),
    offset: String((page - 1) * limit),
  };

  if (params.q) {
    query.search = params.q;
  }

  extraKeys.forEach((key) => {
    if (params[key]) {
      query[key] = params[key];
    }
  });

  return { query, page, limit };
}

// Метадані для компонента пагінації: він показується тільки коли їх передали.
export function buildPaginationMeta({ page, limit, total }) {
  const totalCount = Number(total) || 0;

  return {
    page,
    limit,
    total: totalCount,
    pages: Math.max(Math.ceil(totalCount / limit), 1),
  };
}
